import React from 'react';

import { Button, Typography } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';

import Modal from '../../Modal';
import { TemplateRecord } from '../types';
import { StyledCardHeader, StyledCardContent, StyledCardActions } from './index.styles';

interface DeleteTemplateModalInterface {
    handleDelete: () => void;
    deleteModalIsOpen: boolean;
    closeDeleteModal: () => void;
    templateToDelete: TemplateRecord | null;
}

const DeleteTemplateModal: React.FC<DeleteTemplateModalInterface> = ({ deleteModalIsOpen, closeDeleteModal, templateToDelete, handleDelete }) => {
    const { t } = useTranslation('templates');

    return (
        <Modal noPadding isOpen={deleteModalIsOpen} onClose={closeDeleteModal}>
            <StyledCardHeader>
                <Typography variant="h5">{t('delete-template')}</Typography>
            </StyledCardHeader>
            <StyledCardContent>
                {
                    templateToDelete ?
                        <Trans i18nKey="templates:delete-template-info-message">
                            Are you sure you want to permanently delete <b>{{ templateName: templateToDelete?.class_name }} </b>?
                        </Trans>
                        : null
                }
            </StyledCardContent>

            <StyledCardActions>
                <Button onClick={closeDeleteModal} variant="outlined">{t('cancel')}</Button>
                <Button variant="contained" color="error" onClick={() => handleDelete()}>{t('delete')}</Button>
            </StyledCardActions>
        </Modal>
    );
};

export default DeleteTemplateModal;
